<template>
  <v-container fluid fill-height class="pa-0 pt-2" v-if="selectedApplication">
    <v-dialog v-model="applicationSentDialog" width="500">
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
          style="max-height: 50px;"
        >
          Application Saved
        </v-card-title>
        <v-card-text>
          Your application has been received. We will be in contact.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
          style="max-height: 50px;"
        >
          <v-btn flat color="primary" @click="applicationSentDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addApplicantDialog" persistent>
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
          style="max-height: 50px;"
        >
          Applicant Details
        </v-card-title>
        <v-card-text class="pa-0">
          <v-container grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  placeholder="Given Names"
                  v-model="addApplicant.givenNames"
                  :rules="required"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  placeholder="Surname"
                  v-model="addApplicant.surname"
                  :rules="required"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="mail"
                  placeholder="Email"
                  :rules="emailRules"
                  type="email"
                  v-model="addApplicant.email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  type="tel"
                  prepend-icon="phone"
                  placeholder="(000) 000 - 00000"
                  mask="(###) ### - #####"
                  v-model="addApplicant.phone"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-divider></v-divider>
        <v-card-actions
          style="max-height: 50px;"
        >
          <v-btn flat color="primary" @click="addApplicant ={};addApplicantDialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click="addApplicantSave()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar
      dark
      style="background:#af1c2e"
      fixed
      dense
    >
      <v-toolbar-title>Application</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark outline @click="submitApplication()" v-if="applicantID && !linkExpired()">Submit</v-btn>
    </v-toolbar>
    <template v-if="linkExpired()">
      <v-flex xs12 style="max-width:1000px;margin-left:auto;margin-right:auto;align-self:start" class="pt-3">
        <v-icon color="red darken-2">warning</v-icon>
        This application link has expired. Please contact Braziers if you require it to be reset.
      </v-flex>
    </template>
    <v-layout column v-if="!linkExpired()">
      <v-layout justify-center v-if="primaryApplicant">
        <v-flex xs12 style="max-width:1000px;margin-left:auto;margin-right:auto">
          <v-form>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  Welcome to the Braziers application. Each person over 18 intending to reside in this property is
                  required to submit an application.
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Number of residents under 18"
                                v-model="selectedApplication.nonAdultTenants"
                                default="0"
                                :rules="required"
                                required
                                type="number"
                                @change="tenantCountChanged()"
                                @click="tenantCountChanged()"
                                @keypress="tenantCountChanged()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Number of adult residents (Including primary applicant)"
                                v-model="selectedApplication.adultTenants"
                                :rules="required"
                                required
                                type="number"
                                @change="tenantCountChanged()"
                                @click="tenantCountChanged()"
                                @keypress="tenantCountChanged()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <div class="title">
                    <strong>Primary Applicant: </strong>{{ formData.givenNames }} {{ formData.surname }}
                  </div>
                </v-flex>
                <v-flex xs12>
                  <div class="title">
                    <strong>Other Applicants: </strong>
                  </div>
                </v-flex>
                <v-flex xs12 v-for="otherTenantIndex in otherTenants">
                  <div :key="`tenant_{otherTenantIndex}`">
                    <div class="subheading" v-if="selectedApplication.applicants[otherTenantIndex]">
                      {{selectedApplication.applicants[otherTenantIndex].givenNames}} {{selectedApplication.applicants[otherTenantIndex].surname}} <{{selectedApplication.applicants[otherTenantIndex].email}}>
                    </div>
                    <div class="subheading" v-else>
                      Tenant {{ otherTenantIndex + 1 }}
                      <v-btn @click="addApplicantDialog = true;" dark small
                             v-if="!selectedApplication.applicants[otherTenantIndex]">Enter Details
                      </v-btn>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
      <v-layout justify-center v-if="applicantID">
        <v-flex xs12 style="max-width:1000px;margin-left:auto;margin-right:auto">
          <v-divider/>
          <v-form>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <div class="headline" v-if="primaryApplicant">Primary Tenant Application</div>
                  <div class="headline" v-else>Tenant Application</div>
                  <!--<div class="subheading">Reference <strong>{{ applicationID }}</strong></div>-->
                </v-flex>
                <v-flex xs12>
                  <div class="headline section">Your Identification Picture</div>
                  <div class="subheading section">(Driver's license or passport)</div>
                </v-flex>
                <v-flex xs12 v-if="formData.identificationImageUploaded">
                  <div class="subheading">You have already uploaded your identification. We cannot display it here for security reasons. If you wish to replace the existing one please click "Choose an image"</div>
                </v-flex>
                <v-flex xs12 class="text-xs-center">
                  <croppa v-model="identificationImage"
                          :accept="'image/*'"
                          :input-attrs="{capture: 'environment'}"
                          :prevent-white-space="true"
                          :show-loading="true"
                          canvas-color="white"
                          :width="250"
                          :height="150"
                          :quality="2">
                  </croppa>
                </v-flex>
                <v-flex xs12>
                  <div class="headline section">Your Details</div>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="statusOptions"
                    label="My Status"
                    v-model="formData.status"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Given names"
                    v-model="formData.givenNames"
                    required></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Surname"
                    v-model="formData.surname"
                    required></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-menu
                    ref="dobMenu"
                    lazy
                    :close-on-content-click="false"
                    v-model="dobMenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="formData.dateOfBirth"
                  >
                    <v-text-field
                      slot="activator"
                      label="Birth Date"
                      v-model="computedDateFormatted"
                      prepend-icon="event"
                      color="grey darken-4"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-if="dobMenu"
                      v-model="formData.dateOfBirth"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @change="save"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Home phone"
                    v-model="formData.homePhone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Work phone"
                    v-model="formData.workPhone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Mobile phone"
                    v-model="formData.mobilePhone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="email"
                    :rules="emailRules"
                    label="Email address"
                    v-model="formData.email"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    label="Car Registration Number"
                    v-model="formData.carRego"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <div class="headline section">Credit Record</div>
                </v-flex>
                <v-flex xs12>
                  Do you have any history of a debt collection or default?
                  <v-radio-group v-model="formData.creditHistory" row>
                    <v-radio label="Yes" :value="true" color="red darken-4"></v-radio>
                    <v-radio label="No" :value="false" color="red darken-4"></v-radio>
                  </v-radio-group>
                  <div class="caption">Please note that Brazier Property Investments Ltd MREINZ has a policy of only
                    taking applications from applicants that have a 100% clean credit rating. In proceeding with this
                    application the applicant agrees that Braziers has permission to run a credit check on them at the
                    time of the application or sign-up. The applicant agrees to supply ID in the form of a driver's
                    licence or passport in order for an accurate credit check to be undertaken.
                  </div>
                </v-flex>
                <v-flex xs12 v-if="formData.creditHistory">
                  <div class="subheading cantProceed">Sorry we will not be able to proceed with your application as
                    Braziers has a policy of only taking tenants who have a 100% clean credit rating.
                  </div>
                </v-flex>
                <template v-if="!formData.creditHistory">
                  <v-flex xs12>
                    <div class="headline section">Occupancy</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="stayOptions"
                      label="Probable length of stay"
                      v-model="formData.lengthOfStay"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline section">Current Housing Situation</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :items="currentSituationOptions"
                      label="Current situation"
                      v-model="formData.currentSituation"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-if="formData.currentSituation === `Other`"
                      label="Explanation"
                      type="text"
                      v-model="formData.currentSituationExplanation"
                      class="ml-1"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <vuetify-google-autocomplete
                      id="map"
                      v-model="formData.currentAddress"
                      prepend-icon="map"
                      placeholder="Address"
                      :country="'nz'"
                      v-on:placechanged="getAddressData"
                    >
                    </vuetify-google-autocomplete>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :items="stayOptions"
                      label="How long have you lived there?"
                      v-model="formData.currentAddressLength"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Current rent"
                      type="text"
                      prepend-icon="attach_money"
                      v-model="formData.currentRent"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      label="Reason for moving"
                      type="text"
                      v-model="formData.reasonForMoving"
                    >
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    I consent to you contacting my current/previous landlord (below)
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Landlord/property manager's name"
                      type="text"
                      v-model="formData.landlordName"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Phone"
                      type="text"
                      v-model="formData.landlordPhone"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline section">Employment Details</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :items="incomeSourceOptions"
                      label="Current source of income"
                      v-model="formData.incomeSource"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-if="formData.incomeSource === `Other`"
                      label="Explanation"
                      type="text"
                      v-model="formData.incomeSourceExplanation"
                      class="ml-1"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Weekly income after tax"
                      type="text"
                      prepend-icon="attach_money"
                      v-model="formData.weeklyIncome"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Your position"
                      type="text"
                      v-model="formData.currentEmployerPosition"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Current employer"
                      type="text"
                      v-model="formData.currentEmployerName"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      label="Phone"
                      type="text"
                      v-model="formData.currentEmployerPhone"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      label="Brief details of previous employment"
                      type="text"
                      v-model="formData.previousEmployment"
                    >
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline section">Pets</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                      :items="petOptions"
                      label="Do you have a pet?"
                      v-model="formData.pet"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      v-if="formData.pet === `Other`"
                      label="Explanation"
                      type="text"
                      v-model="formData.petExplanation"
                      class="ml-1"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline section">Referees</div>
                  </v-flex>
                  <v-flex xs12>
                    I agree to you contacting the following referees
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="First Referee Name"
                      type="text"
                      v-model="formData.firstRefereeName"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Relationship"
                      type="text"
                      v-model="formData.firstRefereeRelationship"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Phone/Email"
                      type="text"
                      v-model="formData.firstRefereeContact"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Second Referee Name"
                      type="text"
                      v-model="formData.secondRefereeName"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Relationship"
                      type="text"
                      v-model="formData.secondRefereeRelationship"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Phone/Email"
                      type="text"
                      v-model="formData.secondRefereeContact"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      label="Any other comments related to your application"
                      type="text"
                      v-model="formData.otherComments"
                    >
                    </v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline section">Photographs</div>
                  </v-flex>
                  <v-flex xs12>
                    Brazier Property Investments Ltd MREINZ has a preference to taking photos at property inspections.
                    With your consent these photos are forwarded to the Landlord to specify maintenance needs and show
                    how
                    the property is presented. Brazier Property Investments Ltd MREINZ provides adequate notice for the
                    tenant to remove or cover any of the tenant's private possessions they do not wish to be
                    photographed.
                    The Brazier Property Investments Ltd MREINZ Tenancy Agreement gives the tenant a number of options
                    including the choice not to approve photos being taken, apart from those needed for evidential
                    purposes for Tenancy Tribunal Hearings, from time to time.
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline section">Privacy Act 1993 Statement</div>
                  </v-flex>
                  <v-flex xs12>
                    This application form collects personal information about you.<br/>
                    This information is required to:<br/>
                    <ul>
                      <li>
                        Assess your eligibility as a tenant; and
                      </li>
                      <li>
                        Collect information, which would be provided to a tenant default database and/or credit bureau
                        if you enter into a tenancy agreement and fail to comply with the terms of that agreement. (A
                        tenant default database records the names of the persons who have been found in breach of their
                        tenancy agreement and/or the Residential Tenancies Act 1986 by the Tenancy Tribunal);
                      </li>
                      <li>
                        The information in this tenancy application form will be retained within our office;
                      </li>
                      <li>
                        The information will also be made available to credit bureaux and/or tenant default databases
                        and will be accessible to other people that may inquire of this credit bureau and/or tenant
                        default database;
                      </li>
                      <li>
                        If you do not supply all the information in this form, you may not be considered for a tenancy.
                      </li>
                      <li>
                        You have a right to see the information held about you by any credit bureau or tenant default
                        database and to correct that information in accordance with the Privacy Act.
                      </li>
                    </ul>
                  </v-flex>
                  <v-flex xs12>
                    <div class="headline section">Acceptance</div>
                  </v-flex>
                  <v-flex xs12>
                    <ol>
                      <li>I consent to you making any type of reference, verification or credit check including an
                        online
                        TINZ check and associated databases. I consent to you providing the information in this form and
                        details of any proven breach of my tenancy agreement or of the Residential Tenancies Act 1986 to
                        any credit bureau or tenant default database.<br><br>
                        I acknowledge that the information may then be made publicly available through credit bureau or
                        tenant default databases.<br><br>
                        I agree that you may use any of the information on this application form to enforce any
                        judgement
                        in respect of the Tenancy Agreement or in respect of any order against me by the Tenancy
                        Tribunal.
                      </li>
                      <li>I agree that if I am declined this tenancy for reasons of a bad credit history or Tenancy
                        Tribunal orders against me, I am aware that this may be placed on a tenancy database.
                      </li>
                      <li>I confirm the information in this form is true and correct and that I have read the Privacy
                        Act
                        Statement as stated above.
                      </li>
                    </ol>
                  </v-flex>
                  <v-flex xs12>
                    <v-spacer></v-spacer>
                    <v-btn dark style="background-color:#af1c2e" @click="submitApplication()">Submit Application</v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dobMenu: false,
      identificationImage: null,
      addApplicantDialog: false,
      applicationSentDialog: false,
      addApplicant: {},
      primaryApplicant: false,
      applicationID: null,
      applicantID: null,
      formData: {},
      otherTenants: [],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      required: [
        v => !!v || "Field is required"
      ],
      statusOptions: [
        { value: `Not seen`, text: `I haven't seen the property at all yet` },
        { value: `Seen outside`, text: `I have seen the outside but not yet been inside` },
        { value: `Keen to sign up`, text: `I have seen through the property and am keen to sign up` }
      ],
      stayOptions: [
        { value: `Less than 3 months`, text: `Less than 3 months` },
        { value: `3-6 months`, text: `3-6 months` },
        { value: `6-12 months`, text: `6-12 months` },
        { value: `12 months plus`, text: `12 months plus` }
      ],
      currentSituationOptions: [
        `Renting`, `Own my own home`, `Boarding`, `Recently arrived`, `Other`
      ],
      petOptions: [
        `No pets`, `Cat(s)`, `Dog(s)`, `Other`
      ],
      incomeSourceOptions: [
        `Work`, `Benefit`, `Student loan/allowance`, `Other`
      ]
    }),
    watch: {
      dobMenu (val) {
        val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
      },
      "selectedApplication.adultTenants" (val) {
        let otherTenants = [];
        for (var i = 1; i < val; i++) {
          otherTenants.push(i);
        }
        this.otherTenants = otherTenants;
      }
    },
    computed: {
      ...mapGetters(["currentApplication", "appointmentTenants", "allTenants", "selectedApplication"]),
      computedDateFormatted () {
        return this.$moment(this.formData.dateOfBirth).format("DD/MM/YYYY");
      }
    },
    methods: {
      linkExpired: function() {
        let expiration = null;
        expiration = this.$moment(new Date(this.selectedApplication.linkExpiry.seconds * 1000));
        let today = this.$moment();
        return today.isAfter(expiration);
      },
      loadApplication: function() {
        this.applicationID = this.$route.params.id;
        this.$store.dispatch("loadApplication", this.applicationID).then(() => {
          //if (this.$route.params.applicantID) {
            let applicantID = null;
            if (this.$route.params.applicantID) {
              applicantID = this.$route.params.applicantID;
              this.primaryApplicant = false;
            } else {
              applicantID = this.selectedApplication.applicants[0].applicantID;
              this.primaryApplicant = true;
            }
            this.applicantID = applicantID;

            let applicantData = this.selectedApplication.applicants.find((applicant) => {
              return applicant.applicantID == applicantID;
            });
            if (applicantData) {
              this.formData = applicantData;
            }
          //} else {
          //   this.applicantID = null;
          // }
        });
      },
      addApplicantSave: function() {
        this.$store.dispatch("addApplicant", {
          applicant: this.addApplicant,
          applicationID: this.applicationID
        }).then(() => {
          this.addApplicant = {};
          this.addApplicantDialog = false;
        });
      },
      openPrimary: function() {
        this.loadApplication();
      },
      tenantCountChanged: function() {
        setTimeout(() => {
          this.$store.dispatch("saveTenantCount", {
            nonAdultTenants: this.selectedApplication.nonAdultTenants,
            adultTenants: this.selectedApplication.adultTenants,
            applicationID: this.applicationID
          });
        });
      },
      getAddressData: function(addressData, placeResultData) {
        if (placeResultData) {
          this.formData.currentAddress = placeResultData.formatted_address;
        }
      },
      submitApplication () {
        this.formData.applicationID = this.applicationID;
        if (this.identificationImage.imageSet) {
          this.identificationImage.generateBlob((blob) => {
            this.formData.identificationImage = {
              file: blob,
              name: `ID for ${this.applicationID}/${this.applicantID}`
            };
            this.dispatchSave();
          }, "image/jpeg", 0.9);
        } else {
          this.dispatchSave();
        }
      },
      dispatchSave () {
        this.$store.dispatch("saveApplication", this.formData).then(() => {
          this.applicationSentDialog = true;
          this.loadApplication();
        });
      },
      save (date) {
        this.$refs.dobMenu.save(date);
      },
      goBack () {
        window.history.back();
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadApplication();
      });
    }
  };
</script>

<style scoped>
  .section, .cantProceed {
    color: #af1c2e
  }
</style>
